import React from 'react';
import { VoiceMessage, toDisplayImageUrl } from '../ChatWidget/MessageMedia';
import '../ChatWidget/ChatWidget.css';
import './BroadcastMedia.css';

// A broadcast's attachment — a photo, video, voice message or GIF — on the
// broadcasts lists (the Messages page for clients and coaches, the chat
// bubble) and in the composer's preview. Broadcasts from before attachments
// carry only `imageUrl`.

/** { type, url, media } for a broadcast's attachment, or null. */
export function broadcastAttachment(b) {
  if (b && b.mediaType && b.mediaUrl) return { type: b.mediaType, url: b.mediaUrl, media: b.media || {} };
  if (b && b.imageUrl) return { type: 'image', url: b.imageUrl, media: {} };
  return null;
}

/** The text to show — none when the body only labels the attachment. */
export const broadcastText = (b) => (b && !b.bodyIsLabel && b.body) || '';

/** `compact` sizes it for the chat bubble's narrow list. */
export default function BroadcastMedia({ broadcast, compact = false }) {
  const att = broadcastAttachment(broadcast);
  if (!att) return null;
  const cls = compact ? 'broadcasts-bubble' : 'broadcast';
  if (att.type === 'audio') {
    return (
      <div className={`${cls}-voice`}>
        <VoiceMessage src={att.url} durationSec={att.media.durationSec} waveform={att.media.waveform} />
      </div>
    );
  }
  if (att.type === 'video') {
    return (
      <video
        className={`${cls}-video`}
        src={att.url}
        poster={att.media.posterUrl}
        controls
        preload="metadata"
        playsInline
      />
    );
  }
  if (att.type === 'gif') {
    return (
      <div className={`${cls}-image-link`}>
        <img src={att.url} alt="GIF" className={`${cls}-image`} loading="lazy" />
      </div>
    );
  }
  const src = toDisplayImageUrl(att.url);
  return (
    <a href={src} target="_blank" rel="noopener noreferrer" className={`${cls}-image-link`}>
      <img src={src} alt={broadcast.title || 'Broadcast photo'} className={`${cls}-image`} loading="lazy" />
    </a>
  );
}
